module.exports = __webpack_public_path__ + "img/arw-dx.6cc0a94c.svg";